import React from "react";
import { InputNumber } from "antd";

export default function NumInput({ placeholder = "0", ...props }) {
  return (
    <InputNumber
      min={0}
      style={{ width: "100%" }}
      placeholder={placeholder}
      formatter={(v) => `${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      parser={(v) => v.replace(/,/g, "")}
      {...props}
    />
  );
}
